// Which way this browser signed in last, so the sign-in screen can say so.
//
// It lives in localStorage because the sign-in screen renders before anybody is
// authenticated: the server has no idea who is looking at it. It is a hint on a
// button, never a credential — a wrong or missing value costs nothing.

import type { LoginMethod } from "../../api/auth/provider-sign-in";

const LAST_LOGIN_METHOD_KEY = "last_login_method";

const isLoginMethod = (value: string | null): value is LoginMethod =>
	value === "google" || value === "microsoft" || value === "password";

export const readLastSignInMethod = (): LoginMethod | null => {
	try {
		const stored = window.localStorage.getItem(LAST_LOGIN_METHOD_KEY);
		return isLoginMethod(stored) ? stored : null;
	} catch {
		// Storage can be unavailable (private window, blocked site data). The
		// screen simply shows no "Last used" chip.
		return null;
	}
};

export const rememberSignInMethod = (method: LoginMethod): void => {
	try {
		window.localStorage.setItem(LAST_LOGIN_METHOD_KEY, method);
	} catch {
		// Same: remembering is a convenience, never a requirement.
	}
};
